<template>
  <div class="actions" @mouseleave="fecharSubmenu">
    <div @click.stop>
      <div @mouseenter="abrirSubmenuOcorrencias" class="menu-remessa">
        <span>Ocorrência - E-Sfinge</span>
      </div>

      <div v-show="submenuAberto" class="submenu">
        <div @click.stop="acessarOcorrenciasEnvio" class="submenu-item">
          <span>Enviar</span>
        </div>
        <div v-if="protocolo !== undefined" @click.stop="acessarOcorrenciasProtocolo" class="submenu-item">
          <span>Protocolo</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import {actionTypes, tiposDecisaoOcorrencias, tiposOcorrenciaLicitacao} from "@/commons/constants";

export default {
  name: "LicitacaoAtualizacaoAcoesOcorrencias",
  data() {
    return {
      mostrarDialogOcorrencia: false,
      submenuAberto: false,
      protocolo: undefined,
      tiposDecisaoOcorrencias,
      tiposOcorrenciaLicitacao,
      tipoOcorrenciaLicitacao: '',
      tipoDecisaoOcorrencia: '',
      descricao: '',
      campoObrigatorio: false
    };
  },
  props: {
    licitacaoId: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    abrirSubmenuOcorrencias() {
      this.submenuAberto = !this.submenuAberto;
    },
    fecharSubmenu() {
      this.submenuAberto = false;
    },
    ...mapActions([
        actionTypes.BUSCAR_PROCOTOLO
    ]),
    acessarOcorrenciasEnvio() {
      this.$router.push({ name: 'ocorrenciaEnvioRemessa' })
    },
    acessarOcorrenciasProtocolo() {
      this.$router.push({ name: 'ocorrenciaProtocolo' })
    }
  },
  computed: {
    ...mapState(["loki", "parametros", "licitacao"]),
  },
  async mounted() {
    let payload = {
      licitacaoId: this.$route.params.id,
      operacao: "ocorrenciaLicitacao"
    };

    const response = await this.buscarProtocoloEsfinge(payload)
    if(response !== "") {
      this.protocolo = response
    } else {
      this.protocolo = undefined
    }

    this.$root.$on("menu-principal-fechado", this.fecharSubmenu);
  },
  beforeDestroy() {
    this.$root.$off("menu-principal-fechado", this.fecharSubmenu);
  },
}
</script>

<style>

</style>